/* Accessibility adapter only: persistence and login remain Oxi's responsibility. */
(() => {
  const root = document.querySelector('.ggx-warehouse');
  if (!root || root.dataset.coffeeListReady) return;
  root.dataset.coffeeListReady = 'true';
  const labelButtons = () => {
    root.querySelectorAll('.ggx-series-product').forEach(card => {
      const button = card.querySelector('.oxi-wl-card-btn');
      if (!button) return;
      const title = card.querySelector('.ggx-product-title')?.textContent.trim() || 'this coffee';
      const saved = button.dataset.saveType !== 'none';
      const label = `${saved ? 'Remove' : 'Save'} ${title} ${saved ? 'from' : 'to'} My Favorites`;
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (button.getAttribute('aria-pressed') !== String(saved)) button.setAttribute('aria-pressed', String(saved));
      if (button.type !== 'button') button.setAttribute('type', 'button');
    });
  };
  const labelPanel = () => {
    document.querySelectorAll('.oxi-wl-popup,.oxi-wl-sidebar').forEach(panel => {
      panel.querySelectorAll('a.oxi-wl-login-btn').forEach(link => {
        // Oxi appends a second '?' to Shopify's locale-bearing account URL.
        const original = link.getAttribute('href') || '';
        const marker = original.indexOf('?checkout_url=');
        if (marker < 0 || original.indexOf('?') === marker) return;
        try {
          const url = new URL(original.slice(0, marker), location.origin);
          if (url.origin !== location.origin || url.pathname !== '/customer_authentication/redirect') return;
          url.searchParams.set('checkout_url', original.slice(marker + '?checkout_url='.length));
          link.setAttribute('href', url.href);
        } catch (_) { /* Preserve vendor behavior for unrecognized URLs. */ }
      });
      const heading = panel.querySelector('.oxi-wl-header h3');
      if (heading && heading.textContent !== 'My Favorites') heading.textContent = 'My Favorites';
      panel.querySelectorAll('.oxi-wl-card-btn').forEach(button => { if (button.getAttribute('aria-label') !== 'Remove coffee from My Favorites') button.setAttribute('aria-label', 'Remove coffee from My Favorites'); if (button.type !== 'button') button.setAttribute('type', 'button'); });
      const close = panel.querySelector('.oxi-wl-close');
      if (close && close.getAttribute('aria-label') !== 'Close My Favorites') close.setAttribute('aria-label', 'Close My Favorites');
    });
  };
  labelPanel();
  new MutationObserver(labelPanel).observe(document.body, {childList:true, subtree:true});
  labelButtons();
  new MutationObserver(labelButtons).observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['data-save-type']});
})();

